import documentApiClient, { type ApiDefinition } from '@/tsClient/servers/noodleDocuments';

type ThisApi = ApiDefinition['/document-request-users/{id}']['GET'];
type Input = ThisApi['params'];

const getDocumentRequestUser = async ({ id }: Input): Promise<ThisApi['response']> => {
  const response = await documentApiClient.get(`/document-request-users/${id}`);
  return response.data;
};

export default getDocumentRequestUser;
